// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"directors_wrapper__tdvzL"};